import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { HistoryPeriodEnumKeys, RealFiatAssets } from '@libs/types';

import { CurrencyType } from 'src/constants';

type UserPNL = {
  amount: number;
  percentage?: number;
};

export type GetUserPnlArgs = {
  assetCode?: CurrencyType;
  range: HistoryPeriodEnumKeys;
  valueAssetCode: RealFiatAssets;
};

export type GetUserPnlRes = {
  getUserPNL: DefaultApiResponse<UserPNL>;
};

export const getUserPnlQuery: TypedDocumentNode<
  GetUserPnlRes,
  DefaultArg<GetUserPnlArgs>
> = gql`
  query GetUserPNL($record: GetUserPNLRecord!) {
    getUserPNL(record: $record) {
      amount
      percentage
    }
  }
`;
